export default __webpack_public_path__ + "static/media/vertical-cell-lines.01325f88.jpeg";